import { cacheDom } from '../utils/QuerySelectors.js'
import { makeRequest } from '../utils/Storefront.js'
import { getStoreQuery, formatStoreData } from '../utils/Store.js'
import Fuse from 'fuse.js'

const dom = {}
const qs = {
  section: 'data-section-type="stores-list"',
  reverseSection: 'data-section-type="eyewear-stores-list"',
  swiper: 'data-featured-stores',
  input: 'data-store-zipcode',
  viewAll: 'data-all-stores',
  list: 'data-stores-list',
  current: 'data-store-current',
  template: 'data-store-template',
}
const qsAll = {}
const fuseOptions = {
  includeScore: true,
  threshold: 0.4,
  ignoreLocation: true,
  useExtendedSearch: true,
  keys: [
    {
      name: 'address',
      weight: 2,
    },
    {
      name: 'zipcode',
      weight: 2,
    },
    {
      name: 'city',
      weight: 3,
    },
    {
      name: 'country',
      weight: 4,
    },
    {
      name: 'title',
      weight: 2,
    },
  ],
}
const state = {
  fuse: null,
  countries: {
    en: {
      US: 'United States',
      CA: 'Canada',
      CN: 'China, Mainland',
      IT: 'Italy',
      JP: 'Japan',
      KR: 'South Korea',
      HK: 'Hong Kong SAR',
      PT: 'Portugal',
      TW: 'Taiwan Region',
      UK: 'United Kingdom',
      FR: 'France',
      RU: 'Russian Federation',
      AU: 'Australia',
      MO: 'Macau SAR',
      CH: 'Switzerland',
      DE: 'Germany',
      TH: 'Thailand',
      AE: 'U.A.E.',
      UA: 'Ukraine',
      AT: 'Austria',
      BE: 'Belgium',
      DK: 'Denmark',
      GR: 'Greece',
      KW: 'Kuwait',
      LB: 'Lebanon',
      MG: 'Madagascar',
      MY: 'Malaysia',
      MX: 'Mexico',
      NL: 'Netherlands',
      PH: 'Philippines',
      SK: 'Slovakia',
      ES: 'Spain',
      SE: 'Sweden',
      TK: 'Tokelau',
      SG: 'Singapore',
    },
    ko: {
      US: '미국',
      CA: '캐나다',
      CN: '중국 본토',
      IT: '이탈리아',
      JP: '일본',
      KR: '한국',
      HK: '홍콩 특별행정구',
      PT: '포르투갈',
      TW: '대만 지역',
      UK: '영국',
      FR: '프랑스',
      RU: '러시아 연방',
      AU: '호주',
      MO: '마카오 특별행정구',
      CH: '스위스',
      DE: '독일',
      TH: '태국',
      AE: '아랍에미리트',
      UA: '우크라이나',
      AT: '오스트리아',
      BE: '벨기에',
      DK: '덴마크',
      GR: '그리스',
      KW: '쿠웨이트',
      LB: '레바논',
      MG: '마다가스카르',
      MY: '말레이시아',
      MX: '멕시코',
      NL: '네덜란드',
      PH: '필리핀',
      SK: '슬로바키아',
      ES: '스페인',
      SE: '스웨덴',
      TK: '토켈라우',
      SG: '싱가포르',
    },
    ja: {
      US: 'アメリカ合衆国',
      CA: 'カナダ',
      CN: '中国本土',
      IT: 'イタリア',
      JP: '日本',
      KR: '韓国',
      HK: '香港特別行政区',
      PT: 'ポルトガル',
      TW: '台湾地域',
      UK: 'イギリス',
      FR: 'フランス',
      RU: 'ロシア連邦',
      AU: 'オーストラリア',
      MO: 'マカオ特別行政区',
      CH: 'スイス',
      DE: 'ドイツ',
      TH: 'タイ',
      AE: 'アラブ首長国連邦',
      UA: 'ウクライナ',
      AT: 'オーストリア',
      BE: 'ベルギー',
      DK: 'デンマーク',
      GR: 'ギリシャ',
      KW: 'クウェート',
      LB: 'レバノン',
      MG: 'マダガスカル',
      MY: 'マレーシア',
      MX: 'メキシコ',
      NL: 'オランダ',
      PH: 'フィリピン',
      SK: 'スロバキア',
      ES: 'スペイン',
      SE: 'スウェーデン',
      TK: 'トケラウ',
      SG: 'シンガポール',
    },
  },
}

const getStores = () => {
  const query = getStoreQuery('store', 250)
  makeRequest((results) => {
    window.storesList = results.data?.metaobjects?.edges
      ?.map((edge) => formatStoreData('store', edge))
      .sort((a, b) => a.order - b.order)
  }, query)
}

const renderResults = (results) => {
  dom.swiper.classList.toggle('!hidden', results.length > 0)
  results.forEach((result) => (dom.list.innerHTML += storeHtml(result.item)))
  dom.reverseSection.classList.toggle('!hidden', results.length > 0)
}

const storeHtml = (store) => {
  const div = document.createElement('div')
  div.innerHTML = dom.template.innerHTML

  if (store.media && store.media.length > 0) {
    const media = store.media[0]
    div.querySelector('[data-store-image]').innerHTML = media.previewImage ? `<img src="${media.previewImage?.url}&width=700"
      class="absolute w-full h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      width="${media.previewImage?.width}"
      height="${media.previewImage?.height}"
      alt="${media.previewImage?.altText || ''}"
    />` : ''
  }

  div.querySelector('[data-store-name]').innerHTML = store.title
  div.querySelector('[data-store-head]').href = store.url
  div.querySelector('[data-store-address]').innerHTML = store.addressFull
  div.querySelector('[data-store-time]').innerHTML =
    store.hours +
    (store.phone
      ? `<div><a href="tel:${store.phone.replace(' ', '').replace('-', '')}">${store.phone}</a></div>`
      : '') +
    (store.email ? `<div><a class="underline" href="mailto:${store.email}">${store.email}</a></div>` : '')
  div.querySelector('[data-store-directions]').href = store.directions

  if (store.services && store.services.length > 0) {
    div.querySelector('[data-store-services-wrapper]').classList.remove('hidden')
    store.services.forEach(
      (service) => (div.querySelector('[data-store-services]').innerHTML += `<div>&mdash;&nbsp;${service}</div>`),
    )
  }

  if (store.products && store.products.length > 0) {
    div.querySelector('[data-store-products-wrapper]').classList.remove('hidden')
    store.products.forEach(
      (product) => (div.querySelector('[data-store-products]').innerHTML += `<div>&mdash;&nbsp;${product}</div>`),
    )
  }
  return div.innerHTML
}

export const setupStoresList = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    const swiperElement = dom.section.querySelector(`[${qs.swiper}]`)

    new Swiper(swiperElement, {
      autoplay: {
        delay: 5000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    })

    getStores()
    dom.input.addEventListener('input', (e) => {
      state.fuse = new Fuse(window.storesList, fuseOptions)
      const results = state.fuse.search(e.target.value.trim().toLowerCase()).filter(result => result.score <= 0.0004)
      dom.list.innerHTML = ''
      renderResults(results)
    })
    dom.viewAll.addEventListener('click', () => {
      dom.list.innerHTML = ''
      window.storesList.forEach((store) => (dom.list.innerHTML += storeHtml(store)))
      dom.swiper.classList.add('!hidden')
      dom.reverseSection.classList.add('!hidden')
    })

    dom.current.addEventListener('click', () => {
      fetch('https://ipinfo.io/json')
        .then((res) => res.json())
        .then((res) => {
          //console.log("arsenalia: res",res)
          if (res.city) {
            const locale = window.Shopify?.locale || 'en'
            const countryMap = state.countries[locale] || state.countries['en']
            const countryName = countryMap[res.country]?.toLowerCase()
            //console.log("arsenalia: countryname", countryName)
            const countryStores = countryName
              ? window.storesList.filter((store) => store.country === countryName)
              : window.storesList

              //console.log("arsenalia: countryStores", countryStores)
            state.fuse = new Fuse(countryStores, fuseOptions)
            let results = state.fuse.search(res.city.toLowerCase())
            dom.list.innerHTML = ''
            if (results.length == 0 && res.postal) {
              state.fuse = new Fuse(countryStores, Object.assign(fuseOptions, { useExtendedSearch: true }))
              results = state.fuse.search(`=${res.postal.toLowerCase()}`)
            }
            if (results.length == 0) {
              results = countryStores.map((item) => ({ item, score: 0 }))
            }
            renderResults(results)
          }
        })
    })
  }
}
